export default "__VITE_ASSET__8GVBCe1L__"